import { FC } from 'react';

import classNames from 'classnames';
import getClassNames from '../../utils/getClassNames';

import styles from './StarIcon.module.scss';
import Icon, { IconIds } from '../IconDS22';

export const Themes = [
  'yellow',
  'dark',
  'disabled',
  'midnight01',
] as const;

export const Sizes = [
  'tiny',
  'small',
  'medium',
  'large',
] as const;

export const Features = [
  'listingPage',
  'aggregate',
  'aboutPage',
  'searchPage',
] as const;

export type StarIconProps = {
  half?: boolean;
  theme?: typeof Themes[number];
  size?: typeof Sizes[number];
  feature?: typeof Features[number];
  bordered?: boolean;
  empty?: boolean;
};

const StarIcon: FC<StarIconProps> = ({
  half = false,
  theme = 'yellow',
  size = 'medium',
  bordered,
  empty,
  feature,
}) => {
  let iconId: IconIds = 'star-filled';
  if (half) {
    iconId = 'star-half';
  }
  if (empty) {
    iconId = 'star';

    if (theme === 'dark') {
      iconId = 'star-filled';
    }
  }
  return (
    <Icon
      id={iconId}
      className={
        getClassNames(styles, 'root', classNames(
          feature,
          size,
          theme,
          {
            bordered,
            empty,
          },
        ))
      }
    />
  );
};

export default StarIcon;
